import React from "react";

export type ToothPart = "center" | "top" | "right" | "bottom" | "left";
export type ToothColor = "felling" | "caries" | null;

export interface ToothData {
  id: number; // 1-32
  missing: boolean;
  parts: Record<ToothPart, ToothColor>;
}

interface Props {
  toothId: number;
  data: {
    missing: boolean;
    parts: Record<ToothPart, ToothColor>;
  };
  currentColor: "felling" | "caries";
  onChange: (toothId: number, parts: Record<ToothPart, ToothColor>) => void;
}

const ToothBox: React.FC<Props> = ({
  toothId,
  data,
  currentColor,
  onChange,
}) => {
  const handlePartClick = (part: ToothPart) => {
    if (data.missing) return;
    const newParts = {
      ...data.parts,
      [part]: data.parts[part] === currentColor ? null : currentColor,
    };
    onChange(toothId, newParts);
  };

  const getFill = (part: ToothPart) => {
    const color = data.parts[part];
    if (color === "felling") return "#4ade80";
    if (color === "caries") return "#60a5fa";
    return "#d4d4d4";
  };

  if (data.missing) {
    return (
      <svg viewBox="0 0 100 100" width="50" height="50">
        <rect x="10" y="10" width="80" height="80" fill="#fff" stroke="#aaa" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 100 100" width="50" height="50">
      <polygon
        points="10,10 90,10 50,50"
        fill={getFill("top")}
        stroke="#888"
        strokeWidth="1"
        onClick={() => handlePartClick("top")}
        style={{ cursor: "pointer" }}
      />
      <polygon
        points="90,10 90,90 50,50"
        fill={getFill("right")}
        stroke="#888"
        strokeWidth="1"
        onClick={() => handlePartClick("right")}
        style={{ cursor: "pointer" }}
      />
      <polygon
        points="90,90 10,90 50,50"
        fill={getFill("bottom")}
        stroke="#888"
        strokeWidth="1"
        onClick={() => handlePartClick("bottom")}
        style={{ cursor: "pointer" }}
      />
      <polygon
        points="10,90 10,10 50,50"
        fill={getFill("left")}
        stroke="#888"
        strokeWidth="1"
        onClick={() => handlePartClick("left")}
        style={{ cursor: "pointer" }}
      />
      <rect
        x="35"
        y="35"
        width="30"
        height="30"
        fill={getFill("center")}
        stroke="#888"
        strokeWidth="1"
        onClick={() => handlePartClick("center")}
        style={{ cursor: "pointer" }}
      />
    </svg>
  );
};

export default ToothBox;
